module.exports = __webpack_public_path__ + "img/refresh.66905ad5.svg";